export function parseQueryString(str: string): any {
	const result = {};

	if(str) {
		const pairs = str.split(/&/);

		pairs.forEach(rawPair => {
			const pair = rawPair
				.split(/=/)
				.map(decodeURIComponent);

			result[pair[0]] = pair[1] === undefined ? true : pair[1];
		});
	}

	return result;
}

export function getQueryParamsFromUrl(url: string): any {
	const urlObj = new URL(url);
	return new URLSearchParams(urlObj.search);
}

export function removeQueryParamsFromUrl(url: string, params: string[]): string {
	const queryIndex = url.indexOf('?');
	const hashIndex = url.indexOf('#');
	if(queryIndex < 0 || hashIndex > 0 && hashIndex < queryIndex) {
		return url;
	}
	const schemeHostPath = url.substring(0, queryIndex);
	const hash = hashIndex > 0 ? url.substring(hashIndex - 1) : '';
	const queryParams = url.substring(queryIndex + 1, hashIndex > 0 ? hashIndex : undefined)
		.split('&')
		.filter(param => {
			const [k, v] = param.split('=');
			return !params.includes(k);
		})
		.join('&');
	const queryStr = queryParams ? '?' + queryParams : '';

	return schemeHostPath + queryStr + hash;
}

export function parseUrl(urlStr: string): { scheme, host, port, path } {
	try {
		const url = new URL(urlStr);

		return {
			scheme: url.protocol.replace(':', ''),
			host: url.hostname,
			port: url.port,
			path: url.pathname + url.search + url.hash
		};
	}
	catch {
		return null;
	}
}

export function buildUrl(scheme: string, host: string, port: string, path: string): string {
	return `${scheme}://${host}:${port}${path}`;
}

export function extractQueryParamsFromHash(): any {
	const hash = window.location.hash;
	const queryIndex = hash?.indexOf('?');

	const query = queryIndex >= 0 ? hash?.substring(queryIndex + 1, hash?.length) : undefined;
	return parseQueryString(query);
}

export function getDomainWithProtocol(url: string): string {
	const urlObj = new URL(url);
	return `${urlObj.protocol}//${urlObj.hostname}`;
}
